module.exports = __webpack_public_path__ + "img/oval3.b50246c0.png";